import Vue from 'vue'
import { ConfirmationModalInputInfo, ConfirmationModalInputColor, ConfirmationModalInput } from "./types";

type Resolver = ((value: unknown) => void) | undefined;

export default Vue.extend({
  data(){
    return {
      loadingConfirmation: false,
      isShowConfirmationModal: false,
      isDefaultConfirmOperation: false,
      buttonConfiguration: '',
      confirmationModalInfo: <ConfirmationModalInputInfo> {},
      confirmationModalInfoColor: <ConfirmationModalInputColor>{},
      confirmationCallback: undefined as Resolver
    }
  },
  methods: {
    showConfirmationModal(input?: ConfirmationModalInput){
      this.$data.isDefaultConfirmOperation = input?.isDefaultConfirmOperation;
      if(input?.buttonConfiguration === 'oneBtn'){
        this.$data.buttonConfiguration = 'oneBtn';
        this.$data.confirmationModalInfo = <ConfirmationModalInputInfo>{
          title: input?.title ? input?.title : 'Set Inputs',
          message: input?.message ? input?.message : 'Configure showConfirmationModal() with ConfirmationModatInputInfo Data',
          confirmButtonTitle: input?.confirmButtonTitle ? input?.confirmButtonTitle : 'Ok'
        };
      }

      if(input?.buttonConfiguration !== 'oneBtn'){
        this.$data.buttonConfiguration = 'twoBtns';
        this.$data.confirmationModalInfo = <ConfirmationModalInputInfo>{
          title: input?.title ? input?.title : 'Confirmation',
          message: input?.message ? input?.message : 'Are You Sure You Want To Proceed?',
          confirmButtonTitle: input?.confirmButtonTitle ? input?.confirmButtonTitle : 'Confirm',
          cancelButtonTitle: input?.cancelButtonTitle ? input?.cancelButtonTitle : 'Cancel'
        };
      }

      this.$data.confirmationModalInfoColor = <ConfirmationModalInputColor>{
        titleColor: input?.titleColor ? input?.titleColor : 'black',
        messageColor: input?.messageColor ? input?.messageColor : 'black',
        confirmButtonTitleColor: input?.confirmButtonTitleColor ? input?.confirmButtonTitleColor : 'green',
        cancelButtonTitleColor: input?.cancelButtonTitleColor ? input?.cancelButtonTitleColor : 'grey',
      };
      this.$data.isShowConfirmationModal = true;
    },
    async confirm(input?: ConfirmationModalInput){
      return new Promise(resolve => {
        this.showConfirmationModal(input);
        this.$data.confirmationCallback = resolve;
      });
    },
    confirmationAccept(){
      this.resolveConfirmationPromise(true);
    },
    confirmationReject(){
      this.resolveConfirmationPromise(false);
      this.$data.isShowConfirmationModal = false;
    },
    resolveConfirmationPromise(response: boolean){
      try{
        if(this.$data.confirmationCallback === undefined) return;
        this.$data.confirmationCallback(response);
      }catch{

      }
    },
    defaultCancelOperation(){
      this.$data.isShowConfirmationModal = false;
      this.resolveConfirmationPromise(false);
    },
    startConfirmationLoading(){
      this.$data.loadingConfirmation = true;
    },
    stopConfirmationLoading(){
      this.$data.isShowConfirmationModal = false;
      this.$data.loadingConfirmation = false;
      this.resolveConfirmationPromise(false);
    }
  }
})